var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m403.054 121.885c4.301 0 7.788 12.695 7.788 28.353s-3.487 28.353-7.788 28.353h-363.821c-4.301 0-7.788-12.695-7.788-28.353s3.487-28.353 7.788-28.353z",
    fill: "#b4d2d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.054 161.053c4.301 0 7.788 3.926 7.788 8.769s-3.487 8.769-7.788 8.769h-363.821c-4.301 0-7.788-3.926-7.788-8.769s3.487-8.769 7.788-8.769z",
    fill: "#a1c6cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.241 113.591h386.653v307.225h-386.653zm26.412 26.412v254.401h333.828v-254.401z",
    fill: "#96a4af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.801 99.933 206.766-90.933 206.766 90.933v13.658h-413.532z",
    fill: "#788a98"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m167.626 59.33h99.882v27.491h-99.882z",
    fill: "#e2e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.626 59.33h10v17.491h89.882v10h-99.882z",
    fill: "#c9cbcb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.801 99.933 206.766-90.933 206.766 90.933v9.651l-197.246-86.746-206.357 90.753h-9.929z",
    fill: "#6c7e8d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.241 113.591h10v297.225h376.653v10h-386.653zm36.412 26.412h323.828v244.401h10v-254.401h-333.828z",
    fill: "#8696a3",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 50.655,
    y: 196.014
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.781 196.014h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.379c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.076 196.014h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.613 196.014h-4.093v20.684h-17.444v4.398h21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 119.038,
    y: 264.398
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.164 264.398h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.378c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.46 264.398h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.997 264.398h-4.094v20.683h-17.443v4.398h21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 50.655,
    y: 332.781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.781 332.781h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.378c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.076 332.781h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.613 332.781h-4.093v20.683h-17.444v4.398h21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 50.655,
    y: 264.398
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.781 264.398h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.378c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.076 264.398h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.613 264.398h-4.093v20.683h-17.444v4.398h21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 119.038,
    y: 332.781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.164 332.781h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.378c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.46 332.781h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.997 332.781h-4.094v20.683h-17.443v4.398h21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#da8c36",
    height: 68.38,
    rx: 2.126,
    width: 68.38,
    x: 187.421,
    y: 332.781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.547 332.781h6.378c1.171 0 2.126.955 2.126 2.126v53.498c0 1.171.955 2.126 2.126 2.126h53.498c1.171 0 2.126.955 2.126 2.126v6.378c0 1.171-.955 2.126-2.126 2.126h-64.128c-1.171 0-2.126-.955-2.126-2.126v-64.128c0-1.171.955-2.126 2.126-2.126z",
    fill: "#cd7d25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.843 332.781h21.537v25.081h-21.537z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.843 332.781h4.093v20.683h17.444v4.398h-21.537z",
    fill: "#dee8ee",
    fillRule: "evenodd"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#b4d2d7",
    height: 259.137,
    rx: 11.738,
    width: 220.711,
    x: 252.376,
    y: 243.863
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.35 243.863c6.465 0 11.738 5.273 11.738 11.738v235.661c0 6.465-5.273 11.738-11.738 11.738h-1.63c.085-.568.129-1.147.129-1.738v-235.661c0-6.465-5.273-11.738-11.738-11.738h-195.606c.844-5.646 5.734-10 11.609-10h197.235z",
    fill: "#a1c6cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.284 266.403h178.897v214.056h-178.897z",
    fill: "#eff4f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.284 266.403h16.747v214.056h-16.747z",
    fill: "#dee8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#64b5f6",
    height: 33.407,
    rx: 2.538,
    width: 33.407,
    x: 299.293,
    y: 294.298
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.832 294.298h28.33c1.396 0 2.538 1.142 2.538 2.538v2.781h-22.838c-1.396 0-2.538 1.142-2.538 2.538v25.548h-5.491c-1.396 0-2.538-1.142-2.538-2.539v-28.329c0-1.397 1.142-2.538 2.538-2.538z",
    fill: "#42a5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.241 292.943c4.418 0 8 3.582 8 8s-3.582 8-8 8h-47.614c-4.418 0-8-3.582-8-8s3.582-8 8-8zm23.93 20.116c4.418 0 8 3.582 8 8s-3.582 8-8 8h-71.544c-4.418 0-8-3.582-8-8s3.582-8 8-8z",
    fill: "#96a4af",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#64b5f6",
    height: 33.407,
    rx: 2.538,
    width: 33.407,
    x: 299.293,
    y: 357.339
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.832 357.339h28.33c1.396 0 2.538 1.142 2.538 2.538v2.781h-22.838c-1.396 0-2.538 1.142-2.538 2.538v25.548h-5.491c-1.396 0-2.538-1.142-2.538-2.538v-28.33c0-1.396 1.142-2.538 2.538-2.538z",
    fill: "#42a5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.241 355.984c4.418 0 8 3.582 8 8s-3.582 8-8 8h-47.614c-4.418 0-8-3.582-8-8s3.582-8 8-8zm23.93 20.117c4.418 0 8 3.582 8 8s-3.582 8-8 8h-71.544c-4.418 0-8-3.582-8-8s3.582-8 8-8z",
    fill: "#96a4af",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#64b5f6",
    height: 33.407,
    rx: 2.538,
    width: 33.407,
    x: 299.293,
    y: 420.063
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m301.832 420.063h28.33c1.396 0 2.538 1.142 2.538 2.538v2.781h-22.838c-1.396 0-2.538 1.142-2.538 2.538v25.548h-5.491c-1.396 0-2.538-1.142-2.538-2.538v-28.33c0-1.396 1.142-2.538 2.538-2.538z",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.241 418.709c4.418 0 8 3.582 8 8s-3.582 8-8 8h-47.614c-4.418 0-8-3.582-8-8s3.582-8 8-8zm23.93 20.116c4.418 0 8 3.582 8 8s-3.582 8-8 8h-71.544c-4.418 0-8-3.582-8-8s3.582-8 8-8z",
    fill: "#96a4af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.108 243.863h29.426l-11.708-16.554c-2.632-3.721.018-8.841 4.576-8.841h36.66c4.558 0 7.207 5.12 4.576 8.841l-11.708 16.554h29.426c1.477 0 2.564 1.347 2.252 2.79l-3.979 18.414c-.695 3.217-3.465 5.452-6.756 5.452h-64.283c-3.291 0-6.061-2.235-6.756-5.452l-3.979-18.414c-.312-1.443.775-2.79 2.252-2.79z",
    fill: "#465759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.108 243.863h20.389l3.376 4.774h-25.589l-.429-1.983c-.312-1.443.775-2.79 2.252-2.79zm16.739-20.621h36.554c4.558 0 7.207 5.12 4.576 8.841l-11.708 16.554h29.426c1.477 0 2.564 1.347 2.252 2.79l-3.979 18.414c-.045.21-.1.416-.163.617 2.872-.378 5.195-2.483 5.823-5.391l3.979-18.414c.312-1.443-.776-2.79-2.252-2.79h-29.426l11.708-16.554c2.631-3.721-.018-8.841-4.576-8.841h-36.66c-2.991 0-5.161 2.206-5.555 4.774z",
    fill: "#3e4d4f"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m412.632 402.873 86.834-86.835c2.31-2.309 2.31-6.077 0-8.387l-10.069-10.069c-2.309-2.309-6.077-2.309-8.387 0l-86.834 86.835-7.912 21.943c-.465 1.29-.162 2.647.807 3.617.97.97 2.327 1.273 3.617.808l21.943-7.912z",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.632 402.873 86.834-86.835c2.31-2.309 2.31-6.077 0-8.387l-10.069-10.069c-2.309-2.309-6.077-2.309-8.387 0l-.807.807 9.262 9.262c2.31 2.31 2.31 6.077 0 8.387l-86.834 86.835-16.355 5.898c.171.44.438.85.795 1.207.97.97 2.327 1.273 3.617.808l21.943-7.912z",
    fill: "#ffc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.751 395.992c-3.858-3.858-7.716-7.716-11.574-11.574l-2.77 7.683-5.142 14.26c-.465 1.29-.162 2.647.807 3.617.97.97 2.327 1.273 3.617.808l20.205-7.286 1.738-.627c-1.876-1.877-3.753-3.753-5.63-5.63-.417-.417-.834-.834-1.251-1.251z",
    fill: "#da8c36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.601 405.427-.337.934c-.465 1.29-.162 2.647.807 3.617.97.97 2.327 1.273 3.617.808l20.205-7.286 1.738-.627-5.022-5.022-1.73.624z",
    fill: "#cd7d25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.088 308.636c5.63 5.63 11.261 11.26 16.891 16.891l9.488-9.488c2.31-2.309 2.31-6.077 0-8.387l-10.069-10.069c-2.309-2.309-6.077-2.309-8.387 0l-7.923 7.923-1.565 1.565z",
    fill: "#fdb800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.979 320.526 5 5 9.488-9.488c2.31-2.309 2.31-6.077 0-8.387l-10.069-10.069c-2.309-2.309-6.077-2.309-8.387 0l-.807.806 9.262 9.262c2.31 2.31 2.31 6.077 0 8.387l-4.488 4.488z",
    fill: "#f4a40e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlInventory);
export default __webpack_public_path__ + "static/media/control-inventory.8962d59bd88f209fe17d98d92a8a1fca.svg";
export { ForwardRef as ReactComponent };